export const FEEDBACK_TOPICS = [
  'Missing document',
  'Data error',
  'Wrong analysis',
  'Other',
] as const;

export type FeedbackTopic = (typeof FEEDBACK_TOPICS)[number];

export interface FeedbackRequest {
  conversation_id: string;
  user_name: string;
  user_email: string;
  topic: FeedbackTopic;
  message: string;
}

export interface FeedbackResponse {
  status: string;
  message?: string;
}
